import { render, staticRenderFns } from "./AddSidenav.vue?vue&type=template&id=474191d4"
import script from "./AddSidenav.vue?vue&type=script&lang=js"
export * from "./AddSidenav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports